var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.2502 17.0157c-0.2439 -0.7264 -1.0033 -1.2469 -1.777 -1.2469 -0.9443 0 -1.7769 0.8058 -1.7769 1.7998 0 0.7743 0.5006 1.4491 1.2143 1.6369l1.0039 0.2642c0.785 0.2066 1.3357 0.949 1.3357 1.8006v0.1095c0 1.0329 -0.7956 1.8703 -1.777 1.8703 -0.7737 0 -1.533 -0.5204 -1.7769 -1.2469",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.27956 15.7688 4.44234 7.4813m-0.2961 -7.4813 -4.4424 7.4813",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.2031 15.7688v7.4813h3.5539",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 12.875V5.122c0.0001 -0.19702 -0.0386 -0.39212 -0.114 -0.57417 -0.0753 -0.18205 -0.1857 -0.34747 -0.325 -0.48683L14.689 1.19c-0.281 -0.281385 -0.6623 -0.43965 -1.06 -0.44H2.25c-0.39782 0 -0.77936 0.158035 -1.06066 0.43934C0.908035 1.47064 0.75 1.85218 0.75 2.25v17.5c0 0.3978 0.158035 0.7794 0.43934 1.0607 0.2813 0.2813 0.66284 0.4393 1.06066 0.4393h2.375",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.4512 0.75v4.62769h4.541",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileXls);
export default __webpack_public_path__ + "static/media/file-xls.b87c193367006232c4de7e2181cdb3f6.svg";
export { ForwardRef as ReactComponent };